import moment from 'moment'
import React, { FC } from 'react'
import { OPTIONS } from '../../../../constants/dateOptions'
import { PageBlogPost } from '../../../../models/pages/blogPost'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../utils/blog.utils'
import BlogAd from '../../../global/blogAds'
import { BlogListingContainer } from '../style'
import { BlogPost } from './blogPost'
import { BlogPostGroup } from './blogPostGroup'
import { LastPage } from './lastPage'

type Props = {
  posts: PageBlogPost[]
  isMainBlog: boolean
  locale: string
  blogFRData: any
  subscribe: any
  collectionRowData: any
  pageNumber: any
}

export const Listing: FC<Props> = ({
  posts,
  isMainBlog,
  locale,
  blogFRData,
  subscribe,
  collectionRowData,
  pageNumber,
}) => {
  //* Featured resource
  const generateBlogFR = () => {
    if (blogFRData) {
      const { title, image, imageAlt, ctaText, ctaUrl } = blogFRData

      return (
        <BlogAd
          ctaUrl={ctaUrl}
          ctaText={ctaText}
          adText={title}
          adImage={image}
          adImageAlt={imageAlt}
          className="BlogListing__Ad"
          key="BlogListing__Ad"
        />
      )
    } else {
      return null
    }
  }

  return (
    <BlogListingContainer $totalPost={posts.length}>
      {posts.map((post: PageBlogPost, i: number) => {
        if (!post) return null

        const blogOverwriteUrlText = post.blogCategory?.overwriteUrlText || ''
        const useCase = post?.blogCategory?.useCase || ''
        const blogTitle = post.h1Title || ''
        const blogImageURL = post.mainImage?.image?.file?.url || ''
        const blogImageAlt = post.mainImage?.altText || ''

        const blogCategory = post.blogCategory?.title || ''
        let blogCategoryPath = blogCategory
          .toLowerCase()
          .replace(/ *\([^)]*\) */g, '')
          .replace(/\s/g, '-')

        if (blogCategoryPath === 'artificial-intelligence') {
          blogCategoryPath = 'ai'
        } else if (blogCategoryPath === 'robotic-process-automation') {
          blogCategoryPath = 'rpa'
        }

        const blogDate = post.date ? new Date(post.date) : null
        let convertedDate = ''
        if (blogDate) {
          convertedDate = moment.utc(blogDate).format('MMMM DD, YYYY') //* Example: 9 Jul 2020
          convertedDate = new Date(convertedDate).toLocaleDateString(locale, OPTIONS)
        }

        let blogSubtitle = ''
        if (post.teaserBody?.raw) {
          blogSubtitle = post.teaserBody.raw
        } else if (post.seo?.pageMetaDescription) {
          blogSubtitle = post.seo.pageMetaDescription
        }

        let blogSlug = post.slug || '/blog'
        if (!isMainBlog) {
          blogSlug = generateSecondaryBlogSlug({
            slug: post.slug,
            blogCategoryName: blogOverwriteUrlText ? blogOverwriteUrlText : blogCategory,
            useCase,
            pageLocale: locale,
          })
        } else {
          blogSlug = generateBlogPostSlug({
            slug: blogSlug,
            blogCategoryName: blogOverwriteUrlText ? blogOverwriteUrlText : blogCategory,
            pageLocale: locale,
          })
        }

        const blogPost = (
          <BlogPost
            key={`blogPostItem--${blogSlug}-${i}`}
            blogSlug={blogSlug}
            blogImageURL={blogImageURL}
            blogImageAlt={blogImageAlt}
            blogCategoryPath={blogCategoryPath}
            convertedDate={convertedDate}
            blogTitle={blogTitle}
            blogSubtitle={blogSubtitle}
            blogCategory={blogCategory}
          />
        )

        //* Last item in listing
        if (i === posts.length - 1) {
          return (
            <LastPage
              key={`blogPostGroup--${i}`}
              i={i}
              generateBlogFR={generateBlogFR}
              subscribe={subscribe}
              blogPost={blogPost}
              isMainBlog={isMainBlog}
            />
          )
        } else if (collectionRowData && i === 5 && parseInt(pageNumber) === 1) {
          return (
            <BlogPostGroup
              key={`blogPostGroup--${i}`}
              blogPost={blogPost}
              collectionRowData={collectionRowData}
            />
          )
        } else {
          return blogPost
        }
      })}
    </BlogListingContainer>
  )
}
